import {
  useQuery,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import service from '../service';
import type { TenantApp } from '@Types/contentSlot';

type DefaultError = unknown;

export const appQueryKeys = {
  all: ['apps'] as const,
  list: () => [...appQueryKeys.all, 'list'] as const,
};

type UseAppsParams = {
  enabled?: boolean;
};

/** The tenant's apps (core-db `App` rows) — content-slot targets. */
export function useApps<TData = TenantApp[], TError = DefaultError>(
  { enabled = true }: UseAppsParams = {},
  options?: Omit<
    UseQueryOptions<TenantApp[], TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  return useQuery<TenantApp[], TError, TData>({
    queryKey: appQueryKeys.list(),
    enabled,
    queryFn: async () => service.getApps(),
    staleTime: 60_000,
    ...(options as object),
  });
}
